import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiPaths } from './apiPaths';

const baseQuery = fetchBaseQuery({
    baseUrl: apiPaths.carrickBaseUrl(),
    credentials: 'include',
    prepareHeaders: (headers) => {
        headers.set('accept', 'application/json, text/plain, */*');
        headers.set('content-type', 'application/json');

        return headers;
    },
});

export const carrickApi = createApi({
    reducerPath: 'carrickApi',
    baseQuery: baseQuery,
    endpoints: () => ({}),
});

export default carrickApi;
